import styles from './EquipmentList.module.scss';
import classNames from 'classnames';
import { EquipmentCard, Heading, BackLink, Spinner } from 'ui/components';
import { useContext } from 'react';
import { Container } from 'ui/components/4-habitats';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

export interface EquipmentListProps {
	className?: string;
	columns?: number;
	numberOfProducts: number;
	equipments: Models.Equipment[];
	isLoading?: boolean;
	children?: React.ReactNode;
}

export const EquipmentList = ({ className, columns, equipments, numberOfProducts, isLoading = false, children }: EquipmentListProps) => {
	// Gets column width for Product Card
	const getColumnWidth = (columns: number) => {
		if (columns > 4) columns = 4;
		if (!columns || columns === 1) columns = 2;
		const columnsWidth = Math.round(100 / columns);
		return JSON.stringify(columnsWidth) as Models.GridCellWidth;
	};
	const columnWidth = getColumnWidth(columns);

	// Defines image sizes for Product Card
	const imageSizes = '(max-width: 768px) 50vw, ' + columnWidth + 'vw';
	const dictionary = useContext(DictionaryContext);

	return (
		<Container width="Standard">
			<div className={classNames(styles.EquipmentList)}>
				<Heading headingLevel="h1" style="displayMd" className={styles.AddressSelector_title}>
					{dictionary.getValue('LabOverview.Heading', null, 'My equipment')}
				</Heading>

				<BackLink url="/my-account">{dictionary.getValue('LabOverview.Back')}</BackLink>
				{children}
				<section className={classNames(styles.EquipmentListWrapper, className)}>
					{isLoading ? (
						<Spinner center size="large" />
					) : (
						<div className={classNames(styles.EquipmentListItems, className)}>
							{equipments?.slice(0, numberOfProducts).map((equipment, index) => {
								return (
									<EquipmentCard
										key={equipment.machineUniqueId || `${equipment.equipmentType}-${index}`}
										equipment={equipment as Models.Equipment}
										columnWidth={columnWidth}
										imageSizes={imageSizes}
									/>
								);
							})}
						</div>
					)}
				</section>
			</div>
		</Container>
	);
};
